module.exports = __webpack_public_path__ + "img/comparison_marquee.f526fafb.jpg";